import React from 'react';
import './SimulationToggle.css';

interface SimulationToggleProps {
  simFlag: boolean;
  onToggle: () => void;
  hasChanges?: boolean;
  isLoading?: boolean;
  readOnly?: boolean;
}

/**
 * SimulationToggle component for switching between Live and Simulation modes.
 * Features a gradient background and a bouncing animation when changes are available.
 */
export const SimulationToggle: React.FC<SimulationToggleProps> = ({
  simFlag,
  onToggle,
  hasChanges = false,
  isLoading = false,
  readOnly = false,
}) => {
  return (
    <div className="flex gap-2 items-center">
    <label className='text-black dark:text-gray-300 text-sm'>{simFlag ? "Simulation" : "Live"}</label>
      <div
        className={`simulation-toggle-track ${
          simFlag
            ? "simulation-toggle-track--active"
            : "simulation-toggle-track--inactive"
        } ${
          hasChanges && !isLoading
            ? simFlag
              ? "simulation-toggle-track--hover-sim"
              : "simulation-toggle-track--hover-changes"
            : "simulation-toggle-track--hover-default"
        }`}
        onClick={() => !readOnly && onToggle()}
      >
        <div
          className={`simulation-toggle-knob ${
            simFlag
              ? "simulation-toggle-knob--active"
              : "simulation-toggle-knob--inactive"
          } ${
            !readOnly && hasChanges && !isLoading && !simFlag
              ? "simulation-toggle-knob--bounce"
              : ""
          }`}
        >
          <div
            className={`simulation-toggle-knob-dot ${
              simFlag
                ? "simulation-toggle-knob-dot--active"
                : "simulation-toggle-knob-dot--inactive"
            }`}
          />
        </div>
      </div>
    </div>
  );
};

export default SimulationToggle;
